import React from "react";
import { FaFilePdf, FaFileWord, FaFileImage, FaFileAlt } from "react-icons/fa";
import { buildLeaveDocumentViewUrl, getLeaveDocumentLabel } from "../../../services/Utils";
import "./LeaveDocumentList.css";

const getFileIcon = (doc) => {
  const mime = String(doc?.mime_type || "").toLowerCase();
  const name = String(doc?.file_name || doc?.name || "").toLowerCase();

  if (mime.includes("pdf") || name.endsWith(".pdf")) {
    return FaFilePdf;
  }
  if (mime.includes("word") || name.endsWith(".doc") || name.endsWith(".docx")) {
    return FaFileWord;
  }
  if (mime.includes("image") || /\.(png|jpe?g|gif|webp)$/.test(name)) {
    return FaFileImage;
  }
  return FaFileAlt;
};

const LeaveDocumentList = ({ documents = [], emptyText = "No documents uploaded." }) => {
  if (!documents?.length) {
    return <span className="leave-document-list__empty">{emptyText}</span>;
  }

  return (
    <ul className="leave-document-list">
      {documents.map((doc, idx) => {
        const Icon = getFileIcon(doc);
        const label = getLeaveDocumentLabel(doc);
        const url = buildLeaveDocumentViewUrl(doc);

        if (!url) {
          return (
            <li key={doc?.id || idx} className="leave-document-list__item leave-document-list__unavailable">
              {label} (link unavailable)
            </li>
          );
        }

        return (
          <li key={doc?.id || idx} className="leave-document-list__item">
            <a
              href={url}
              target="_blank"
              rel="noreferrer"
              className="leave-document-list__link"
            >
              <Icon className="leave-document-list__icon" />
              <span>{label}</span>
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default LeaveDocumentList;
